/**
 * Alternate Forms Data - Special official forms like Deoxys, Rotom, Giratina, etc.
 * 
 * Forms not included in the first 1025 of PokeAPI.
 * IDs start at 30001 to avoid conflicts with:
 * - Regular/Base: 1-1025
 * - Megas: 10001+
 * - Regionals: 20001+
 */

export const ALTERNATE_FORMS = [
  // === DEOXYS FORMS ===
  {
    id: 30001,
    name: 'Deoxys-Attack',
    baseName: 'deoxys',
    baseId: 386,
    apiName: 'deoxys-attack',
    apiId: 10001,
    types: ['psychic'],
    ability: 'pressure',
    isForm: true,
    stats: { hp: 50, attack: 180, defense: 20, spAtk: 180, spDef: 20, speed: 150 },
    bst: 600
  },
  {
    id: 30002,
    name: 'Deoxys-Defense',
    baseName: 'deoxys',
    baseId: 386,
    apiName: 'deoxys-defense',
    apiId: 10002,
    types: ['psychic'],
    ability: 'pressure',
    isForm: true,
    stats: { hp: 50, attack: 70, defense: 160, spAtk: 70, spDef: 160, speed: 90 },
    bst: 600
  },
  {
    id: 30003,
    name: 'Deoxys-Speed',
    baseName: 'deoxys',
    baseId: 386,
    apiName: 'deoxys-speed',
    apiId: 10003,
    types: ['psychic'],
    ability: 'pressure',
    isForm: true,
    stats: { hp: 50, attack: 95, defense: 90, spAtk: 95, spDef: 90, speed: 180 },
    bst: 600
  },
  // === GIRATINA ORIGIN ===
  {
    id: 30004,
    name: 'Giratina-Origin',
    baseName: 'giratina',
    baseId: 487,
    apiName: 'giratina-origin',
    apiId: 10007,
    types: ['ghost', 'dragon'],
    ability: 'levitate',
    isForm: true,
    stats: { hp: 150, attack: 120, defense: 100, spAtk: 120, spDef: 100, speed: 90 },
    bst: 680
  },
  // === ROTOM FORMS ===
  {
    id: 30005,
    name: 'Rotom-Heat',
    baseName: 'rotom',
    baseId: 479,
    apiName: 'rotom-heat',
    apiId: 10008,
    types: ['electric', 'fire'],
    ability: 'levitate',
    isForm: true,
    stats: { hp: 50, attack: 65, defense: 107, spAtk: 105, spDef: 107, speed: 86 },
    bst: 520
  },
  {
    id: 30006,
    name: 'Rotom-Wash',
    baseName: 'rotom',
    baseId: 479,
    apiName: 'rotom-wash',
    apiId: 10009,
    types: ['electric', 'water'],
    ability: 'levitate',
    isForm: true,
    stats: { hp: 50, attack: 65, defense: 107, spAtk: 105, spDef: 107, speed: 86 },
    bst: 520
  },
  {
    id: 30007,
    name: 'Rotom-Frost',
    baseName: 'rotom',
    baseId: 479,
    apiName: 'rotom-frost',
    apiId: 10010,
    types: ['electric', 'ice'],
    ability: 'levitate',
    isForm: true,
    stats: { hp: 50, attack: 65, defense: 107, spAtk: 105, spDef: 107, speed: 86 },
    bst: 520
  },
  {
    id: 30008,
    name: 'Rotom-Fan',
    baseName: 'rotom',
    baseId: 479,
    apiName: 'rotom-fan',
    apiId: 10011,
    types: ['electric', 'flying'],
    ability: 'levitate',
    isForm: true,
    stats: { hp: 50, attack: 65, defense: 107, spAtk: 105, spDef: 107, speed: 86 },
    bst: 520
  },
  {
    id: 30009,
    name: 'Rotom-Mow',
    baseName: 'rotom',
    baseId: 479,
    apiName: 'rotom-mow',
    apiId: 10012,
    types: ['electric', 'grass'],
    ability: 'levitate',
    isForm: true,
    stats: { hp: 50, attack: 65, defense: 107, spAtk: 105, spDef: 107, speed: 86 },
    bst: 520
  },
  // === KYUREM FORMS ===
  {
    id: 30010, name: 'Kyurem-White', baseName: 'kyurem', baseId: 646, apiName: 'kyurem-white', apiId: 10022,
    types: ['dragon', 'ice'], ability: 'turboblaze', isForm: true,
    stats: { hp: 125, attack: 120, defense: 90, spAtk: 170, spDef: 100, speed: 95 }, bst: 700
  },
  {
    id: 30011, name: 'Kyurem-Black', baseName: 'kyurem', baseId: 646, apiName: 'kyurem-black', apiId: 10023,
    types: ['dragon', 'ice'], ability: 'teravolt', isForm: true,
    stats: { hp: 125, attack: 170, defense: 100, spAtk: 120, spDef: 90, speed: 95 }, bst: 700
  },
  // === ZYGARDE FORMS ===
  {
    id: 30012, name: 'Zygarde-10%', baseName: 'zygarde', baseId: 718, apiName: 'zygarde-10', apiId: 10118,
    types: ['dragon', 'ground'], ability: 'aura-break', isForm: true,
    stats: { hp: 54, attack: 100, defense: 71, spAtk: 61, spDef: 85, speed: 115 }, bst: 486
  },
  {
    id: 30013, name: 'Zygarde-Complete', baseName: 'zygarde', baseId: 718, apiName: 'zygarde-complete', apiId: 10120,
    types: ['dragon', 'ground'], ability: 'power-construct', isForm: true,
    stats: { hp: 216, attack: 100, defense: 121, spAtk: 91, spDef: 95, speed: 85 }, bst: 708
  },
  // === NECROZMA FORMS ===
  {
    id: 30014, name: 'Necrozma-Dusk-Mane', baseName: 'necrozma', baseId: 800, apiName: 'necrozma-dusk', apiId: 10155,
    types: ['psychic', 'steel'], ability: 'prism-armor', isForm: true,
    stats: { hp: 97, attack: 157, defense: 127, spAtk: 113, spDef: 109, speed: 77 }, bst: 680
  },
  {
    id: 30015, name: 'Necrozma-Dawn-Wings', baseName: 'necrozma', baseId: 800, apiName: 'necrozma-dawn', apiId: 10156,
    types: ['psychic', 'ghost'], ability: 'prism-armor', isForm: true,
    stats: { hp: 97, attack: 113, defense: 109, spAtk: 157, spDef: 127, speed: 77 }, bst: 680
  },
  {
    id: 30016, name: 'Necrozma-Ultra', baseName: 'necrozma', baseId: 800, apiName: 'necrozma-ultra', apiId: 10157,
    types: ['psychic', 'dragon'], ability: 'neuroforce', isForm: true,
    stats: { hp: 97, attack: 167, defense: 97, spAtk: 167, spDef: 97, speed: 129 }, bst: 754
  },
  // === URSHIFU FORMS ===
  {
    id: 30017, name: 'Urshifu-Rapid-Strike', baseName: 'urshifu', baseId: 892, apiName: 'urshifu-rapid-strike', apiId: 10163,
    types: ['fighting', 'water'], ability: 'unseen-fist', isForm: true,
    stats: { hp: 100, attack: 130, defense: 100, spAtk: 63, spDef: 60, speed: 97 }, bst: 550
  },
  // === CALYREX FORMS ===
  {
    id: 30018, name: 'Calyrex-Ice', baseName: 'calyrex', baseId: 898, apiName: 'calyrex-ice', apiId: 10193,
    types: ['psychic', 'ice'], ability: 'as-one-glastrier', isForm: true,
    stats: { hp: 100, attack: 165, defense: 150, spAtk: 85, spDef: 130, speed: 50 }, bst: 680
  },
  {
    id: 30019, name: 'Calyrex-Shadow', baseName: 'calyrex', baseId: 898, apiName: 'calyrex-shadow', apiId: 10194,
    types: ['psychic', 'ghost'], ability: 'as-one-spectrier', isForm: true,
    stats: { hp: 100, attack: 85, defense: 80, spAtk: 165, spDef: 100, speed: 150 }, bst: 680
  },
  // === TERAPAGOS FORMS ===
  {
    id: 30020, name: 'Terapagos-Terastal', baseName: 'terapagos', baseId: 1024, apiName: 'terapagos-terastal', apiId: 10276,
    types: ['normal'], ability: 'tera-shell', isForm: true,
    stats: { hp: 95, attack: 95, defense: 110, spAtk: 105, spDef: 110, speed: 85 }, bst: 600
  },
  {
    id: 30021, name: 'Terapagos-Stellar', baseName: 'terapagos', baseId: 1024, apiName: 'terapagos-stellar', apiId: 10277,
    types: ['normal'], ability: 'teraform-zero', isForm: true,
    stats: { hp: 160, attack: 105, defense: 110, spAtk: 130, spDef: 110, speed: 85 }, bst: 700
  }
];

export function getAlternateFormsAsPokemonList() {
  return ALTERNATE_FORMS.map(form => {
    const spriteUrl = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${form.apiId}.png`;
    return {
      id: form.id,
      name: form.name.toLowerCase().replace(/ /g, '-'),
      displayName: form.name,
      isForm: true,
      isAlternate: true,
      baseId: form.baseId,
      baseName: form.baseName,
      types: form.types,
      stats: form.stats,
      bst: form.bst,
      ability: form.ability,
      apiId: form.apiId,
      apiName: form.apiName,
      spriteUrl: spriteUrl
    };
  });
}

export default ALTERNATE_FORMS;
